export const CsvMappingEntityType = {
  ADVANCE_ANALYSIS_ROW: 'AdvanceAnalysisRow',
  PURCHASE_ADVICE_ANALYSIS_ROW: 'PurchaseAdviceAnalysisRow',
  WAREHOUSE_PURCHASE_ADVICE_ANALYSIS_ROW: 'WarehousePurchaseAdviceAnalysisRow',
};
